import { usePasswordEditorState } from 'hooks/usePasswordEditorState';

export const usePasswordSubmitDidSucceed = () => {
  const { submitDidSucceed } = usePasswordEditorState();

  return submitDidSucceed;
};
